import { useEffect, useState } from "react";
import apiRequest from "../../../../../utils/ApiRequest/apiRequest.js";
import parse from "html-react-parser";
import Pagination from "../../../../Reusable/Pagination/Pagination.js";
import AccountStatusLevelsHeader from "./AccountStatusLevelsHeader.js";
import JumboPayTableContainer from "../Utils/JumboPayTable/JumboPayTableContainer.js";
import { LinkToNewTab } from "../../../../Elements/Link/Link.js";
import { useContent } from "../../../../../contexts/contentContext/contentContext.js";

import "../JumboPay.scss";

const AccountStatus = ({ userData }) => {
  const { getTextByKey, getLanguageCulture, getDirection } = useContent();
  const [allData, setAllData] = useState(null);
  const [userLevel, setUserLevel] = useState(null);
  const [userNextLevel, setUserNextLevel] = useState(null);
  const [userCompleteLevels, setUserCompleteLevels] = useState(null);
  const [percentForNextLevel, setPercentForNextLevel] = useState(0);
  const [amountForNextLevel, setAmountForNextLevel] = useState(null);
  const [userBalanceConverted, setUserBalanceConverted] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [maxPages, setMaxPages] = useState(1);
  const [loading, setLoading] = useState(true);
  const [isActiveSub, setIsActiveSub] = useState(null);
  const [emptyTransactions, setEmptyTransactions] = useState(false);
  const headerTable = [
    {
      enName: "Request Date",
      constName: "payment-request-date",
      className: "header-request-date",
    },
    {
      enName: "Status",
      constName: "payment-status",
      className: "header-status",
    },
    {
      enName: "Action",
      constName: "payment-action",
      className: "header-action",
    },
    {
      enName: "Amount",
      constName: "payment-amount",
      className: "header-amount",
    },
    {
      enName: "Referrer mail",
      constName: "payment-referrar-mail",
      className: "header-referrer-mail",
    },
  ];

  const getAllActions = async (currentPageNum) => {
    setLoading(true);
    const parameters = {
      culture: getLanguageCulture(),
      top: 10,
      from: currentPageNum * 10 - 10,
    };
    const response = await apiRequest(
      "Users",
      "GetAllUserTransactionsPagination",
      parameters
    );
    if (response.status === "success") {
      if (response.data) {
        setMaxPages(response.data.TransactionsCount);
        setAllData(response.data.TransactionsList);
        if (response.data.TransactionsCount === 0) {
          setEmptyTransactions(true);
        } else {
          setEmptyTransactions(false);
        }
      }
    }
    setLoading(false);
  };

  //upper the num of pages
  function up(v, n) {
    return Math.ceil(v * Math.pow(10, n)) / Math.pow(10, n);
  }

  const fixRequestDate = (requestDate) => {
    let temp = requestDate;
    if (requestDate.includes("#Payment_transaction_id#")) {
      temp = requestDate.replace(
        "#Payment_transaction_id#",
        getTextByKey("payment-transaction-id")
      );
    }
    return temp;
  };

  const fixStatusDisplay = (status) => {
    let temp = status;
    if (status.includes("#Payment_status_complete#")) {
      temp = status.replace(
        "#Payment_status_complete#",
        getTextByKey("payment-status-complete")
      );
    } else if (status.includes("#Payment_status_canceled#")) {
      temp = status.replace(
        "#Payment_status_canceled#",
        getTextByKey("payment-status-canceled")
      );
    } else if (status.includes("#Payment_status_pending#")) {
      temp = status.replace(
        "#Payment_status_pending#",
        getTextByKey("payment-status-pending")
      );
    } else if (status.includes("#Payment_withdrawal_request_status#")) {
      temp = status.replace(
        "#Payment_withdrawal_request_status#",
        getTextByKey("payment-request-withdrawal")
      );
    } else if (status.includes("#Payment_status_reject#")) {
      temp = status.replace(
        "#Payment_status_reject#",
        getTextByKey("payment-status-reject")
      );
    }
    return temp;
  };
  const fixActionDisplay = (action) => {
    let temp = action;
    if (action.includes("#Payment_sent_to#")) {
      temp = action.replace(
        "#Payment_sent_to#",
        getTextByKey("payment-sent-to")
      );
    } else if (action.includes("#Payment_recived_from#")) {
      temp = action.replace(
        "#Payment_recived_from#",
        getTextByKey("payment-receive-from")
      );
    } else if (action.includes("#Payment_Status_Requested#")) {
      temp = action.replace(
        "#Payment_Status_Requested#",
        getTextByKey("payment-status-request")
      );
    } else if (action.includes("#Payment_withdrawal_request_status#")) {
      temp = action.replace(
        "#Payment_withdrawal_request_status#",
        getTextByKey("payment-request-withdrawal")
      );
    }

    return temp;
  };

  const fixRefferalMail = (refferalMail) => {
    let temp = refferalMail;
    // if (refferalMail.includes("#DownloadURL#")) {
    //   temp = refferalMail.replace("#DownloadURL#", "#check#");
    // }
    if (refferalMail.includes("#Payment_Recevied_Mail_alt#")) {
      temp = refferalMail.replace(
        "#Payment_Recevied_Mail_alt#",
        getTextByKey("payment-received-mail-alt")
      );
    }
    return temp;
  };

  useEffect(() => {
    getAllActions(currentPage);
  }, [currentPage]);

  const getUserLevel = async () => {
    const response = await apiRequest("JumboFee", "GetUserLevel");
    if (response.status === "success") {
      if (response.data) {
        setUserLevel(response.data);
      }
    }
  };

  const getUserNextLevel = async () => {
    const response = await apiRequest("JumboFee", "GetUserNextLevel");
    if (response.status === "success") {
      if (response.data) {
        setUserNextLevel(response.data);
        getUserTotalIncomeBalance(response.data);
      }
    }
  };

  const getUserTotalIncomeBalance = async (nextLevel) => {
    const parameters = {
      userId: userData.UserId,
    };
    const response = await apiRequest(
      "Users",
      "GetUserTotalIncomeBalance",
      parameters
    );
  };

  const GetUserTotalIncomeBalance = async (nextLevel) => {
    const response = await apiRequest("Users", "GetUserTotalIncomeBalance");
    if (response.status === "success") {
      if (response.data.toString()) {
        let userRevenue = response.data;
        moneyNumberFormat(
          nextLevel.MinAmount > 0
            ? nextLevel.MinAmount - Number(userRevenue)
            : 1
        );
        setPercentForNextLevel((userRevenue * 100) / nextLevel.MinAmount);
      }
    }
  };

  const moneyNumberFormat = async (strNumber) => {
    const parameters = {
      NumberAsString: strNumber,
    };
    const response = await apiRequest(
      "JumboFee",
      "MoneyNumberFormat",
      parameters
    );
    if (response.status === "success") {
      if (response.data.toString()) {
        setAmountForNextLevel(response.data);
      }
    }
  };

  const NumberFormat = async (strNumber) => {
    const parameters = {
      NumberAsString: strNumber,
    };
    const response = await apiRequest("JumboFee", "NumberFormat", parameters);
    if (response.status === "success") {
      if (response.data) {
        setUserBalanceConverted(response.data);
      }
    }
  };

  const getUserAvailableBalance = async () => {
    const response = await apiRequest("Users", "GetUserAvailableBalance");
    if (response.status === "success") {
      if (response.data) {
        setUserBalanceConverted(response.data);
      }
    }
  };
  useEffect(() => {
    if (userLevel != null) {
      if (userLevel.Name === "JUMBOPro" || userLevel.Name === "JUMBOBusiness") {
        setIsActiveSub(true);
      } else {
        setIsActiveSub(false);
        if (userLevel.percentFromComplete === 100) {
          setUserCompleteLevels(true);
        }
      }
    }
  }, [userLevel, userNextLevel]);

  useEffect(() => {
    getUserLevel();
    getUserNextLevel();
    getUserAvailableBalance();
    //getAllActions(1);
  }, []);

  const bodyTable = [
    {
      fieldClass: `item-request-date ${
        getDirection() === "rtl" ? "request-date-rtl" : ""
      }`,
      fieldName: "RequestDateConverted",
      render: (item) => parse(fixRequestDate(item.RequestDateConverted)),
    },
    {
      fieldClass: `item-status`,
      fieldName: "Status",
      render: (item) => parse(fixStatusDisplay(item.Status)),
    },
    {
      fieldClass: `item-action`,
      fieldName: "Action",
      render: (item) => parse(fixActionDisplay(item.Action)),
    },
    {
      fieldClass: `item-amount`,
      fieldName: "AmountWithCurrency",
      render: (item) => parse(item.AmountWithCurrency),
    },
    {
      fieldClass: `item-referral-mail`,
      fieldName: "Referral_Mail",
      render: (item) => parse(fixRefferalMail(item.Referral_Mail)),
    },
  ];

  const mobileRenderRow = (item, i) => {
    return (
      <div key={i} className="row-item-table">
        <div className="item-request-date">
          {parse(item.RequestDateConverted)}
          <span className="status">{parse(fixStatusDisplay(item.Status))}</span>
        </div>
        <div className="item-action mobile-style">
          {parse(fixActionDisplay(item.Action))}
        </div>
        <div className="item-amount mobile-style">
          <span className="type">{getTextByKey("payment-amount")}</span>
          {parse(item.AmountWithCurrency)}
        </div>
        <div className="item-referral-mail mobile-style">
          <span className="type">{getTextByKey("payment-referrar-mail")}</span>
          <LinkToNewTab
            className="mail_referal"
            page={`gallery/${item.mailEncryptedId}`}
            isNewTab={true}
            rel="noopener noreferrer"
          >
            <i className="fas fa-external-link-alt"></i>
          </LinkToNewTab>
        </div>
      </div>
    );
  };

  function truncateToTwoDecimals(num) {
    const str = num.toString();
    const decimalIndex = str.indexOf(".");
    if (decimalIndex === -1) return str; // No decimal point found
    return str.substring(0, decimalIndex + 3); // Extract two digits after the decimal point
  }

  return (
    <div className="account-status-container">
      {!emptyTransactions ? (
        <div className="header">
          <div className={`left-side ${!isActiveSub ? "" : "is-subsriber"}`}>
            <div className="title">
              <h1>{getTextByKey("account-status-title")}</h1>
            </div>
            {isActiveSub !== false ? (
              <div className="subscriber-status">
                {userLevel
                  ? userLevel.Name + " Subscriber: " + userLevel.FeeAmount + "%"
                  : null}
              </div>
            ) : (
              <AccountStatusLevelsHeader
                userLevel={userLevel}
                userNextLevel={userNextLevel}
                userCompleteLevels={userCompleteLevels}
                amountForNextLevel={amountForNextLevel}
                percentForNextLevel={percentForNextLevel}
              />
            )}
          </div>
          <div className="right-side">
            <div
              className={`user-balance ${!isActiveSub ? "" : "subs-balance"}`}
            >
              <div className="account-balance">
                {userBalanceConverted && (
                  <div className="inside-box">
                    <span className="text">
                      {getTextByKey("payment-available-balance")}
                    </span>
                    <span className="currency">
                      {" "}
                      ₪{" "}
                      <span className="amount">
                        {truncateToTwoDecimals(userBalanceConverted)}
                      </span>{" "}
                      ILS
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="header">
          <div className="left-side">
            <div className="title">
              <h1>{getTextByKey("account-status-title")}</h1>
            </div>
          </div>
        </div>
      )}
      <div className="data-table">
        {!emptyTransactions && (
          <h3>{getTextByKey("payment-transaction-history")}</h3>
        )}
        <JumboPayTableContainer
          data={allData}
          tableSecture={bodyTable}
          headerTable={headerTable}
          mobileRowRender={mobileRenderRow}
          emptyTransactions={emptyTransactions}
          loading={loading}
          emptyTransactionsText="payment-no-history"
        />
        {!emptyTransactions && !loading && maxPages > 10 && (
          <Pagination
            currentPage={currentPage}
            maxPages={maxPages > 0 ? up(maxPages / 10, 0) : 1}
            setCurrentPage={setCurrentPage}
          />
        )}
      </div>
    </div>
  );
};

export default AccountStatus;
// {convertDate(new Date(item.RequestDate))}
